import createReducer from 'reducers/createReducer';

import { ItemNotification } from 'actions/actionTypes';

const INITIAL_STATE = {
    // 아이템 알림 정보
    data: null,
    error: {
        triggered: false,
        message: '',
    },
};

const reducer = createReducer(INITIAL_STATE, {
    [ItemNotification.LOAD_ITEM_NOTIFICATION_REQUEST] : (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ItemNotification.LOAD_ITEM_NOTIFICATION_SUCCESS] : (state, action) => {
        state.data = action.payload;
    },
    [ItemNotification.LOAD_ITEM_NOTIFICATION_FAILURE] : (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload?.errorMessage,
        };
    },
})

export default reducer;